import React, { useState, useEffect } from 'react';
import { Box, Skeleton, Typography, useMediaQuery } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import styles from './styles';
import priceFormatter from '../../../util/priceFormatter';

const EirCartPriceSummary = ({ cartData, loading }) => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up('md'));
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const [price, setPrice] = useState('');

  useEffect(() => {
    if (Object.keys(cartData).length >= 1) {
      setPrice(cartData.monthlyTotal);
    }
  }, [cartData]);

  return (
    <Stack direction='row' justifyContent='flex-end' spacing={3} sx={{ mb: sm ? 0.5 : 0 }}>
      {cartData.offerType !== 'PREPAY' && (
        <>
          <Box sx={styles(theme).priceContainer}>
            <Typography variant='body3' sx={styles(theme).priceTitle}>
              Monthly cost{md ? ':' : ''}
            </Typography>
            {!loading ? (
              <Typography variant='h6' sx={styles(theme).totalPrice}>
                {priceFormatter(parseFloat(price))}
              </Typography>
            ) : (
              <Skeleton width='4rem' height='1.5rem' sx={{ ml: 1 }} />
            )}
          </Box>
          {cartData.hasUpfrontCostItem && (
            <Box sx={styles(theme).priceContainer}>
              <Typography variant='body3' sx={styles(theme).priceTitle}>
                Pay today{md ? ':' : ''}
              </Typography>

              {!loading ? (
                <Typography variant='h6' sx={styles(theme).totalPrice}>
                  {priceFormatter(parseFloat(cartData.payTodayTotal))}
                </Typography>
              ) : (
                <Skeleton width='4rem' height='1.5rem' sx={{ ml: 1 }} />
              )}
            </Box>
          )}
        </>
      )}
      {cartData.offerType === 'PREPAY' && (
        // eslint-disable-next-line
        <>
          {cartData.offerType === 'PREPAY' && (
            <Box sx={styles(theme).priceContainer}>
              <Typography variant='body3' sx={styles(theme).priceTitle}>
                Pay today{md ? ':' : ''}
              </Typography>

              {!loading ? (
                <Typography variant='h6' sx={styles(theme).totalPrice}>
                  {priceFormatter(parseFloat(cartData.payTodayTotal))}
                </Typography>
              ) : (
                <Skeleton width='4rem' height='1.5rem' sx={{ ml: 1 }} />
              )}
            </Box>
          )}
        </>
        // eslint-disable-next-line
      )}
    </Stack>
  );
};
export default EirCartPriceSummary;
